import React from 'react'

const NotFound = () => {
  return (
    <div>
        <h1 className='text-center text-warning p-2'>Page Not Found</h1>

    </div>
  )
}

export default NotFound;